import React, { Component } from 'react';
import { List, Modal } from 'antd';
import Resources from '../scripts/resources';

class MessageView extends Component {
    render() {
        const { data, onClose, visible } = this.props;

        let type;

        switch (data.type) {
            case '1':
                type = `${Resources.questions} ${Resources.public}`;
                break;
            case '2':
                type = `${Resources.questions} ${Resources.buy}`;
                break;
            case '3':
                type = `${Resources.questions} ${Resources.payment}`;
                break;
            default:
                type = '-';
                break;
        }

        return (
            <Modal
                title={Resources.view}
                visible={visible}
                onCancel={onClose}
                footer={false}
                width={700}>
                <List>
                    <List.Item>
                        <List.Item.Meta title={Resources.section} description={type} />
                    </List.Item>
                    <List.Item>
                        <List.Item.Meta title={Resources.question} description={data.question} />
                    </List.Item>
                    <List.Item>
                        <List.Item.Meta title={Resources.answer} description={data.answer} />
                    </List.Item>
                </List>
            </Modal>
        );
    }
};

export default MessageView;